export default __webpack_public_path__ + "static/media/heroimage.761d8726.jpg";